import { render, staticRenderFns } from "./TranslationCases.vue?vue&type=template&id=5cbba50f&scoped=true&"
import script from "./TranslationCases.vue?vue&type=script&lang=js&"
export * from "./TranslationCases.vue?vue&type=script&lang=js&"
import style0 from "./TranslationCases.vue?vue&type=style&index=0&id=5cbba50f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbba50f",
  null
  
)

export default component.exports